module.exports = __webpack_public_path__ + "static/junda-caa76d5a2b96f4fd39603226426dfbb2.jpg";